import React from "react";
import { useSEO } from "../hooks/useSEO";

export default function Contact() {
  useSEO({
    title: "Contact",
    description: "Get in touch with Predict90 at support@predict90.com.",
    keywords: "contact, support, help, Predict90",
  });

  return (
    <div className="min-h-screen bg-paper text-ink">
      <div className="mx-auto max-w-2xl px-4 py-10 md:px-6 md:py-14">
        <h1 className="text-[28px] font-bold leading-tight md:text-[32px]">Contact</h1>
        <p className="mt-4 text-[15px] leading-relaxed text-muted">
          Questions, stuck on verify, or want to bring a group next session — email{" "}
          <a href="mailto:support@predict90.com" className="font-semibold text-brand hover:underline">
            support@predict90.com
          </a>
          .
        </p>
        <p className="mt-3 text-[15px] leading-relaxed text-muted">
          Or say hello on{" "}
          <a
            href="https://discord.gg/jGpvZqNRFj"
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold text-brand hover:underline"
          >
            Discord
          </a>
          .
        </p>
      </div>
    </div>
  );
}
